const EMPTY_VALUE_PLACEHOLDER = "--";
const STOCK_SPLIT = "StockSplit";

const EVENT_NAME_COLUMN_ID = "event";

const CompanyTabs = {
  PriceVolume: "Price and $ Volume",
  BidAskPrice: "Bid-Ask Price",
  ReportedMarks: "Reported Marks",
  BidAskRatio: "Bid-Ask Ratio",
  RelativeActivity: "Relative Activity",
  CompanyProfile: "Company Profile",
  CompanyNews: "News",
};

const ERROR_MESSAGE = "An error has occurred";

const companyProfileBreakpoint = 1600;

const FETCH_NEXT_COMPANIES_PAGE_THRESHOLD = 100;
const MIN_SEARCH_QUERY_LENGTH = 1;

export {
  ERROR_MESSAGE,
  EVENT_NAME_COLUMN_ID,
  CompanyTabs,
  companyProfileBreakpoint,
  STOCK_SPLIT,
  EMPTY_VALUE_PLACEHOLDER,
  FETCH_NEXT_COMPANIES_PAGE_THRESHOLD,
  MIN_SEARCH_QUERY_LENGTH,
};
